import { createFileRoute } from '@tanstack/react-router';
import { Header } from '../components/layout/Header';
import { BottomNav } from '../components/layout/BottomNav';
import { EventTypeModal } from '../components/events/EventTypeModal';

export const Route = createFileRoute('/events/create/')({
  component: CreateEventIndexPage,
});

function CreateEventIndexPage() {
  return (
    <div className="min-h-screen bg-black text-white pb-32">
      <Header />
      <EventTypeModal />
      <BottomNav />
    </div>
  );
}
